import { v4 as uuid } from "uuid";
import { z } from "zod";
import { LocalContentType } from "../../entities/packageLocalContent";
export const projectLocalContentLineItemSchema = z.object({
    anzValueAdd: z.number(),
    contractContent: z.number(),
    created: z.date(),
    districtValueAdd: z.number(),
    id: z.string(),
    importValueAdd: z.number(),
    itemDescription: z.string(),
    localContentType: z.enum(LocalContentType),
    localValueAdd: z.number(),
    projectId: z.string(),
    regionalValueAdd: z.number()
});
export const createDefaultProjectLocalContent = (projectId) => {
    return {
        anzValueAdd: 0,
        contractContent: 0,
        created: new Date(),
        districtValueAdd: 0,
        id: uuid(),
        importValueAdd: 0,
        itemDescription: "",
        localContentType: LocalContentType.Building,
        localValueAdd: 0,
        projectId,
        regionalValueAdd: 0
    };
};
// Queensland default local content item descriptions
const QUEENSLAND_LOCAL_CONTENT_ITEMS = [
    "Site Preparation",
    "Demolition Services",
    "Concrete Supply",
    "Formwork & Reinforcement",
    "Scaffolding",
    "Civil Works",
    "Structural Steel",
    "Precast Panels",
    "Cranes & Rigging",
    "Reinforcing Steel",
    "Aggregates & Cement",
    "Bricks & Blocks",
    "Timber",
    "Roofing Materials",
    "Windows & Glazing",
    "Doors & Hardware",
    "HVAC",
    "Electrical",
    "Fire Systems",
    "Plumbing",
    "Water Treatment",
    "BMS Systems",
    "Security Systems",
    "ICT Cabling",
    "AV Systems",
    "Renewable Energy",
    "Partitions & Ceilings",
    "Painting & Coatings",
    "Joinery",
    "Floor Coverings",
    "Signage",
    "Furniture & Fittings",
    "Plant Hire",
    "Traffic Control",
    "Waste Management",
    "Cleaning",
    "Temporary Facilities",
    "Labour Hire",
    "Engineering Services",
    "Project Management",
    "Safety Services",
    "Indigenous Engagement",
    "Training Providers",
    "Procurement Support",
    "PPE & Consumables",
    "Tools",
    "Freight & Transport",
    "Landscaping",
    "Water Tanks & Irrigation"
];
export const createDefaultLocalContentsForProject = (projectId, country, state) => {
    // Only Queensland (AU/QLD) gets default local contents
    if (country === "AU" && state === "QLD") {
        return QUEENSLAND_LOCAL_CONTENT_ITEMS.map((itemDescription) => ({
            anzValueAdd: 0,
            contractContent: 0,
            created: new Date(),
            districtValueAdd: 0,
            id: uuid(),
            importValueAdd: 0,
            itemDescription,
            localContentType: LocalContentType.Building,
            localValueAdd: 0,
            projectId,
            regionalValueAdd: 0
        }));
    }
    // All other locations return empty array
    return [];
};
export const isRegionalOrDistrictLocalContentEnabled = (projectLocalContent) => {
    return projectLocalContent.some((item) => item.regionalValueAdd > 0 || item.districtValueAdd > 0);
};
